import { LucideProps, Package } from 'lucide-react';
import { ComponentType } from 'react';

import { Card } from './ui/Card';

interface NoContentFallbackProps {
  show?: boolean;
  title?: string;
  description?: string;
  icon?: ComponentType<LucideProps>; // Ícone opcional
}

export function NoContentFallback({
  show = true,
  title = 'Nada encontrado',
  description = 'Nenhum item disponível no momento.',
  icon: Icon = Package, // ÍCONE PADRÃO
}: NoContentFallbackProps) {
  if (!show) return null;

  return (
    <div className="flex items-center justify-center">
      <Card className="w-full max-w-md border-0 p-8 text-center shadow-none">
        <div
          className={`mx-auto mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-gradient-to-br from-blue-500/10 to-purple-500/10`}
        >
          <Icon className={`h-10 w-10 text-gray-500`} />
        </div>
        <h3 className="text-xl font-semibold text-gray-900 dark:text-gray-100">
          {title}
        </h3>
        <p className="leading-relaxed text-gray-600 dark:text-gray-400">
          {description}
        </p>
      </Card>
    </div>
  );
}
